module.exports = __webpack_public_path__ + "assets/img/car05.f72ebb31.jpg";